import { useSpiritoryModal } from '@/context/SpiritoryModalProvider';
import { MessageCookie } from '@/types/common';
import parseWithType from '@/utilites/parse-with-type';
import { deleteCookie, getCookie } from 'cookies-next';
import { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import cookiesConstants from '@/constants/cookies.constants';
export default function MessageModal() {
  const modal = useSpiritoryModal();
  const { t: tCommon } = useTranslation('common');
  useEffect(() => {
    const messageCookie = getCookie(cookiesConstants.COOKIES.MESSAGE.name);
    const messageCookieParsed = parseWithType<MessageCookie>(messageCookie);

    if (messageCookieParsed) {
      modal.initModal({
        title: '',
        body: tCommon(messageCookieParsed.message),
        type: messageCookieParsed.type,
        submitAction: () => modal.closeModal(),
      });
      deleteCookie(cookiesConstants.COOKIES.MESSAGE.name);
    }
  }, []);

  return null;
}
